const getPaymentDataPush = (value?: string, invoiceNo?: string) => ({
  payment: {
    value,
    currency: "gbp",
    invoiceNo,
  },
});

export default getPaymentDataPush;
